
// core components/views for Admin layout
import MultiLoggerGraphWrapper from 'views/Groups/MultiLoggerGraphWrapper'
import DashboardWrapper from 'views/Dashboard/DashboardWrapper'
import AdminUserWrapper from 'views/IdentityAdmin/AdminUserWrapper'
import AdminUsers from 'views/IdentityAdmin/AdminUsers'
import DndDashboard from "views/Dashboard/DndDashboard.tsx";
import DeviceList from "views/Devices/DeviceList.tsx";
import Groups from "views/Groups/Groups.tsx";
import SitesWrapper from "views/Sites/SitesWrapper.tsx";
import UsersWrapper from 'views/Users/UsersWrapper'
import Users from "views/Users/Users.tsx";
import SiteDetailsWrapper from "./views/Sites/SiteDetailsWrapper.tsx";
import NewSites2024 from './views/Sites/NewSites2024.tsx'
import SiteAlarmConfigs from "./views/Sites/SiteAlarms.tsx";
import DeviceDetailsWrapper from "views/Devices/DeviceDetailsWrapper.tsx";
import DeviceOverview from "views/Devices/DeviceOverview.tsx";
import GroupDetail from "./views/Groups/GroupDetail.js";
import AlarmList from "views/Alarms/AlarmList.tsx";
import ConnectionsList from "views/Connections/ConnectionsList.tsx";
import NonReportingDeviceList from "views/Devices/NonReportingDeviceList.tsx"
import Contacts from "views/Contacts/Contacts.tsx";
import ContactDetail from "views/Contacts/ContactDetail.tsx";
import Tasks from "views/Tasks/Tasks.tsx";
import UnprocessedBlocks from "views/LogBlocks/UnprocessedBlocksList";
import DeploymentList from "views/Devices/DeploymentList";
import UndeployedDeviceList from "views/Devices/UndeployedLoggers";
import DormantDeviceList from "views/Devices/DormantDeviceList";
import FirmwareUpdates from "views/Devices/FirmwareUpdates";
import UpdatesPending from "views/Devices/UpdatesPending";
import Companies from "views/IdentityAdmin/Companies";
import Downloads from "views/IdentityAdmin/Downloads";
import Support from "views/Support/Support"
import MultiLoggerGraphV2 from "views/Groups/MultiLoggerGraphV2";
import LCLDeviceDetail from "views/Devices/NewLCLDeviceDetail";
import LCLDeviceDetailsWrapper from "views/Devices/LCDeviceDetailsWrapper";
import Firmware from "views/IdentityAdmin/Firmware";
import MQTTResends from "views/IdentityAdmin/MQTTResends";
import SystemInfos from "views/IdentityAdmin/SystemInfos";
import LaiwaDevicesOverview from 'views/IdentityAdmin/LaiwaDevicesOverview'
import SmartCameraOverview from 'views/IdentityAdmin/SmartCameraOverview'
import ReleaseNotes from 'views/IdentityAdmin/ReleaseNotes'
import ImportData from 'views/IdentityAdmin/ImportData'
// @mui/icons-material
import Dashboard from "@mui/icons-material/Dashboard";
import Loggers from "@mui/icons-material/SettingsRemote";
import Alarms from '@mui/icons-material/NotificationImportant';
import MapIcon from '@mui/icons-material/Map';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TextureIcon from '@mui/icons-material/Texture';
import PeopleIcon from '@mui/icons-material/People';
import ListAltIcon from '@mui/icons-material/ListAlt';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import PersonIcon from '@mui/icons-material/Person';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import MessageIcon from '@mui/icons-material/Message';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MultipleDevicesIcon from 'assets/jss/material-dashboard-react/components/MultipleDevicesIcon'
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import CompanyDetails from "./views/UserCompany/CompanyDetails";
import NewDashboard2023 from './views/Dashboard/NewDashboard2023';
import NewSiteDetail2024 from './views/Sites/NewSiteDetail2024';
import DeviceDetail from './views/Devices/DeviceDetail.tsx'


const hideMobile = false

const dashboardRoutes = [

    {
        path: "/dashboard",
        name: "Dashboard",
        icon: Dashboard,
        component: hideMobile ? NewDashboard2023 : DashboardWrapper,
        layout: "/portal",
        visible: true,
        roles:['user', 'useradmin', 'restricteduser', 'identityadmin'],
        alerts: 0
    },
    //{
    //    path: "/DndDashboard",
    //    name: "DndDashboard",
    //    icon: Dashboard,
    //    component: DndDashboard,
    //    layout: "/portal",
    //    visible: true,
    //    roles: ['identityadmin'],
    //    alerts: 0
    //},
    /*{
        path: "/map",
        name: "Map",
        icon: MapIcon,
        component: MapView,
        layout: "/portal",
        visible: true,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/Regions",
        name: "Regions",
        icon: TextureIcon,
        component: Regions,
        layout: "/portal",
        visible: true,
        roles:['user', 'useradmin'],
        alerts: 0
    }, */
    {
        path: "/Groups",
        name: "Groups",
        icon: GroupWorkIcon,
        component: Groups,
        layout: "/portal",
        visible: true,
        roles:['user', 'useradmin'],
        alerts: 0
    },
    {
        path: "/GroupDetail",
        name: "GroupDetail",
        icon: LocationOnIcon,
        component: GroupDetail,
        layout: "/portal",
        visible: false,
        roles: ['user', 'useradmin'],
        alerts: 0
    },
    {
        path: "/multiLoggerGraph",
        name: "MultiLoggerGraph",
        icon: AutoGraphIcon,
        component: hideMobile ? MultiLoggerGraphV2 : MultiLoggerGraphWrapper,
        layout: "/portal",
        visible: false,
        roles: ['user', 'useradmin', 'identityadmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/Sites",
        name: "Sites / Areas",
        icon: MultipleDevicesIcon,
        component: hideMobile ? NewSites2024 : SitesWrapper,
        layout: "/portal",
        visible: true,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    //{
    //    path: "/reports",
    //    name: "Reports",
    //    icon: AssessmentIcon,
    //    component: Reports,
    //    layout: "/portal",
    //    visible: true,
    //    roles: ['user', 'useradmin', 'restricteduser'],
    //    alerts: 0
    //},
    {
        path: "/SiteDetail",
        name: "SiteDetail",
        icon: LocationOnIcon,
        component: hideMobile ? NewSiteDetail2024 : SiteDetailsWrapper,
        layout: "/portal",
        visible: false,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/SiteAlarmConfigs",
        name: "SiteAlarmConfigs",
        icon: LocationOnIcon,
        component: SiteAlarmConfigs,
        layout: "/portal",
        visible: false,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/devices",
        name: "Devices",
        icon: Loggers,
        component: DeviceList,
        layout: "/portal",
        id: "devices",
        visible: true,
        roles: ['user', 'useradmin', 'identityadmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/DeviceDetail",
        name: "DeviceDetail",
        icon: Loggers,
        component: hideMobile ? DeviceDetail : DeviceDetailsWrapper,
        layout: "/portal",
        id: "deviceDetail",
        visible: false,
        roles: ['user', 'useradmin', 'identityadmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/LCLDeviceDetail",
        name: "LCLDeviceDetail",
        icon: Loggers,
        component: hideMobile ? LCLDeviceDetail : LCLDeviceDetailsWrapper,
        layout: "/portal",
        id: "lclDeviceDetail",
        visible: false,
        roles: ['user', 'useradmin', 'identityadmin', 'restricteduser'],
        alerts: 0
    },    {
        path: "/DeviceOverview",
        name: "DeviceOverview",
        icon: Loggers,
        component: DeviceOverview,
        layout: "/portal",
        id: "deviceOverview",
        visible: false,
        roles: ['user', 'useradmin', 'identityadmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/DeploymentList",
        name: "DeploymentList",
        icon: Loggers,
        component: DeploymentList,
        layout: "/portal",
        id: "DeploymentList",
        visible: false,
        roles: ['user', 'useradmin', 'identityadmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/UndeployedLoggers",
        name: "UndeployedLoggers",
        icon: Loggers,
        component: UndeployedDeviceList,
        layout: "/portal",
        id: "UndeployedDeviceList",
        visible: false,
        roles: ['user', 'useradmin', 'identityadmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/FirmwareUpdates",
        name: "FirmwareUpdates",
        icon: Loggers,
        component: FirmwareUpdates,
        layout: "/portal",
        id: "FirmwareUpdates",
        visible: false,
        roles: ['user', 'useradmin'],
        alerts: 0
    },
    {
        path: "/UpdatesPending",
        name: "UpdatesPending",
        icon: Loggers,
        component: UpdatesPending,
        layout: "/portal",
        id: "UpdatesPending",
        visible: false,
        roles: ['user', 'useradmin'],
        alerts: 0
    },
    {
        path: "/AlarmList",
        name: "AlarmList",
        icon: Alarms,
        component: AlarmList,
        layout: "/portal",
        id: "alarmList",
        visible: false,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/ConnectionsList",
        name: "ConnectionsList",
        icon: Loggers,
        component: ConnectionsList,
        layout: "/portal",
        id: "connectionsList",
        visible: false,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/NonReportingDeviceList",
        name: "NonReportingDeviceList",
        icon: Loggers,
        component: NonReportingDeviceList,
        layout: "/portal",
        id: "NonReportingDeviceList",
        visible: false,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/DormantDeviceList",
        name: "DormantDeviceList",
        icon: Loggers,
        component: DormantDeviceList,
        layout: "/portal",
        id: "DormantDeviceList",
        visible: false,
        roles: ['user', 'useradmin'],
        alerts: 0
    },
    {
        path: "/Contacts",
        name: "Alarm Contacts",
        icon: PeopleIcon,
        component: Contacts,
        layout: "/portal",
        visible: true,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/ContactDetail",
        name: "ContactDetail",
        icon: PeopleIcon,
        component: ContactDetail,
        layout: "/portal",
        visible: false,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    {
        path: "/UnprocessedBlocks",
        name: "UnprocessedBlocks",
        icon: PeopleIcon,
        component: UnprocessedBlocks,
        layout: "/portal",
        visible: false,
        roles: ['user', 'useradmin'],
        alerts: 0
    },
    {
        path: "/Support",
        name: "Support",
        icon: FilePresentIcon,
        component: Support,
        layout: "/portal",
        visible: true,
        roles: ['user', 'useradmin', 'restricteduser'],
        alerts: 0
    },
    //{
    //    path: "/LogEvents",
    //    name: "Log Readings",
    //    icon: Dashboard,
    //    component: LogEvents,
    //    layout: "/admin"
    //}
    //,
    //{
    //    path: "/user",
    //    name: "User Profile",
    //    icon: Person,
    //    component: UserProfile,
    //    layout: "/admin"
    //},
    //{
    //    path: "/notifications",
    //    name: "Notifications",
    //    icon: Notifications,
    //    component: NotificationsPage,
    //    layout: "/admin"
    //}
    //,
    {
        path: "/Users",
        name: "Users",
        icon: PersonIcon,
        component: hideMobile ? Users : UsersWrapper,
        layout: "/portal",
        visible: true,
        roles: ['user', 'useradmin'],
        alerts: 0
    },
    /*{
        path: "/Tasks",
        name: "Tasks",
        icon: ListAltIcon,
        component: Tasks,
        layout: "/portal",
        visible: true,
        roles: ['useradmin'],
        alerts: 0
    },*/
    
    /*{
        path: "/Companies",
        name: "Companies",
        icon: GroupWorkIcon,
        component: Companies,
        layout: "/portal",
        visible: true,
           /*sessionStorage.getItem('userLevel') === 'identityadmin',  ||

            (sessionStorage.getItem('userLevel') === 'useradmin'
                && window.location.hostname.includes('zonelog')
                && sessionStorage.getItem('companyId') === '57'
            ),
            //identity or zonelog / gutermann useradmin
            
        roles: ['useradmin', 'identityadmin'],
        alerts: 0
    },*/
    {
        path: "/UserCompanies",
        name: "Company",
        icon: GroupWorkIcon,
        component: CompanyDetails,
        layout: "/portal",
        visible:  true,
        roles: ['useradmin', 'user'],
        alerts: 0
    },
    {
        path: "/Companies",
        name: "Companies",
        icon: GroupWorkIcon,
        component: Companies,
        layout: "/portal",
        visible: true,
        roles: ['useradmin', 'identityadmin'],
        alerts: 0
    },
    
    {
        path: "/AdminUsers",
        name: "Manage Users",
        icon: PeopleIcon,
        component: hideMobile ? AdminUsers : AdminUserWrapper,
        layout: "/portal",
        visible: true,
        roles: ['identityadmin'],
        alerts: 0
    },
    {
        path: "/MqttResends",
        name: "MQTT Resends",
        icon: AllInboxIcon,
        component: MQTTResends,
        layout: "/portal",
        visible: true,
        roles: ['identityadmin'],
        alerts: 0
    },
    {
        path: "/Laiwa",
        name: "Laiwa Devices",
        icon: Loggers,
        component: LaiwaDevicesOverview,
        layout: "/portal",
        visible: false,
        roles: ['identityadmin', 'user'],
        alerts: 0
    },
    {
        path: "/smartcamera",
        name: "Smart Camera POC",
        icon: Loggers,
        component: SmartCameraOverview,
        layout: "/portal",
        visible: false,
        roles: ['identityadmin', 'user'],
        alerts: 0
    },
    {
        path: "/Downloads",
        name: "Downloads",
        icon: FilePresentIcon,
        component: Downloads,
        layout: "/portal",
        visible: true,
        roles: ['identityadmin'],
        alerts: 0
    },
    {
        path: "/Firmware",
        name: "Firmware",
        icon: FilePresentIcon,
        component: Firmware,
        layout: "/portal",
        visible: true,
        roles: ['identityadmin'],
        alerts: 0
    },
    {
        path: "/SystemInfos",
        name: "System Messages",
        icon: MessageIcon,
        component: SystemInfos,
        layout: "/portal",
        visible: true,
        roles: ['identityadmin'],
        alerts: 0
    },
    {
        path: "/ReleaseNotes",
        name: "Release Notes",
        icon: NewReleasesIcon,
        component: ReleaseNotes,
        layout: "/portal",
        visible: true,
        roles: ['identityadmin'],
        alerts: 0
    },
    {
        path: "/ImportData",
        name: "Import Data",
        icon: NewReleasesIcon,
        component: ImportData,
        layout: "/portal",
        visible: window.location.hostname.includes('stw.aquaguard.cloud') || window.location.hostname.includes("localhost") ? true : false,
        roles: ['identityadmin'],
        alerts: 0
    }
    
];

export default dashboardRoutes;
